import React from 'react';

export default function ThemeToggle() {
  return null;
}
